import * as Yup from "yup";
import { LanguageTranslation } from "../../components/language-translation/LanguageTranslation";

export const CurrentPasswordValidation = (langId: string) =>
  Yup.string().trim().required(
    LanguageTranslation({ 
      labelName: "web_current_password_required", 
      languageCode: langId 
    }) || "Current Password is required"
  );

export const NewPasswordValidation = (langId: string) =>
  Yup.string()
    .trim()
    .required(
      LanguageTranslation({ 
        labelName: "web_new_password_required", 
        languageCode: langId 
      }) || "New Password is required"
    )
    .matches(
      /(?=.*[A-Z])/,
      LanguageTranslation({ 
        labelName: "web_password_capital_letter", 
        languageCode: langId 
      }) || "Password needs to have at least one capital letter"
    )
    .matches(
      /(?=.*[!@#$%^&*])/,
      LanguageTranslation({ 
        labelName: "web_password_special_char", 
        languageCode: langId 
      }) || "Password needs to have at least one special character"
    )
    .matches(
      /(?=.*[a-z])/,
      LanguageTranslation({ 
        labelName: "web_password_lowercase", 
        languageCode: langId 
      }) || "Password needs to have at least one lower case character"
    )
    .matches(
      /(?=.*[0-9])/,
      LanguageTranslation({ 
        labelName: "web_password_number", 
        languageCode: langId 
      }) || "Password needs to have at least one number"
    )
    .min(
      8,
      LanguageTranslation({ 
        labelName: "web_password_min_length", 
        languageCode: langId 
      }) || "Password must contain minimum 8 letters without space"
    )
    .max(15);

export const ConfirmPasswordValidation = (langId: string) =>
  Yup.string()
    .label("confirm password")
    .required(
      LanguageTranslation({ 
        labelName: "web_confirm_password_required", 
        languageCode: langId 
      }) || "Confirm Password is required"
    )
    .oneOf(
      [Yup.ref("password") || null],
      LanguageTranslation({ 
        labelName: "web_password_mismatch", 
        languageCode: langId 
      }) || "Confirm password must match with New Password"
    );

export const resetPasswordValidationSchema = (langId: string) => 
  Yup.object().shape({
    current_password: Yup.string()
    .transform((value) => value.replace(/\s/g, ''))
    .required(
      LanguageTranslation({ 
        labelName: "web_current_password_required", 
        languageCode: langId 
      }) || "Current Password is required"
    )
    .trim(),
    new_password: Yup.string()
      .transform((value) => value.replace(/\s/g, ''))
      .required(
        LanguageTranslation({ 
          labelName: "web_new_password_required", 
          languageCode: langId 
        }) || "New Password is required"
      )
      .matches(
        /^(?=.*[A-Z])/,
        LanguageTranslation({ 
          labelName: "web_password_capital_letter", 
          languageCode: langId 
        }) || "Password needs to have at least one capital letter"
      )
      .matches(
        /^(?=.*[!@#$%^&*])/,
        LanguageTranslation({ 
          labelName: "web_password_special_char", 
          languageCode: langId 
        }) || "Password needs to have at least one special character"
      )
      .matches(
        /^(?=.*[a-z])/,
        LanguageTranslation({ 
          labelName: "web_password_lowercase", 
          languageCode: langId 
        }) || "Password needs to have at least one lower case character"
      )
      .matches(
        /^(?=.*[0-9])/,
        LanguageTranslation({ 
          labelName: "web_password_number", 
          languageCode: langId 
        }) || "Password needs to have at least one number"
      )
      .min(
        8,
        LanguageTranslation({ 
          labelName: "web_password_min_length_simple", 
          languageCode: langId 
        }) || "Password must contain minimum 8 letters"
      )
      .trim(),
        
    confirm_password: Yup.string()
      .transform((value) => value.replace(/\s/g, ""))
      .required(
        LanguageTranslation({ 
          labelName: "web_confirm_password_required", 
          languageCode: langId 
        }) || "Confirm Password is required"
      )
      .oneOf(
        [Yup.ref('new_password')], 
        LanguageTranslation({ 
          labelName: "web_password_mismatch_simple", 
          languageCode: langId 
        }) || "Passwords must match"
      )
      .trim(),
  });


  export const resetPasswordValidationSchemaThoughEmail = (langId: string) =>
  Yup.object().shape({
    new_password: Yup.string()
      .transform((value) => value.replace(/\s/g, ''))
      .required(
        LanguageTranslation({
          labelName: "web_new_password_required",
          languageCode: langId,
        }) || "New Password is required"
      )
      .matches(
        /^(?=.*[A-Z])/,
        LanguageTranslation({
          labelName: "web_password_capital_letter",
          languageCode: langId,
        }) || "Password needs to have at least one capital letter"
      )
      .matches(
        /^(?=.*[!@#$%^&*])/,
        LanguageTranslation({
          labelName: "web_password_special_char",
          languageCode: langId,
        }) || "Password needs to have at least one special character"
      )
      .matches(
        /^(?=.*[a-z])/,
        LanguageTranslation({
          labelName: "web_password_lowercase",
          languageCode: langId,
        }) || "Password needs to have at least one lower case character"
      )
      .matches(
        /^(?=.*[0-9])/,
        LanguageTranslation({
          labelName: "web_password_number",
          languageCode: langId,
        }) || "Password needs to have at least one number"
      )
      .min(
        8,
        LanguageTranslation({
          labelName: "web_password_min_length_simple",
          languageCode: langId,
        }) || "Password must contain minimum 8 letters"
      ),
    confirm_password: Yup.string()
      .transform((value) => value.replace(/\s/g, ""))
      .required(
        LanguageTranslation({
          labelName: "web_confirm_password_required",
          languageCode: langId,
        }) || "Confirm Password is required"
      )
      .oneOf(
        [Yup.ref('new_password')],
        LanguageTranslation({
          labelName: "web_password_mismatch_simple",
          languageCode: langId,
        }) || "Passwords must match"
      ),
  });